import { Segmented as AntSegmented, type SegmentedProps } from 'antd'
import type { SegmentedValue } from 'antd/es/segmented'

// antd 5 defaulted Segmented to `middle`, antd 6 takes `large` from our `componentSize`
export const Segmented = <T extends SegmentedValue>({
  size = 'middle',
  ...props
}: SegmentedProps<T>) => {
  return <AntSegmented {...props} size={size} />
}
